import {Button, Dialog, Label, Pane, Text, TextInput, TextInputField, toaster, Tooltip} from "evergreen-ui";
import React from "react";
import {generateExcel, generateExcelViaTemplateId, saveTemplate} from "./ApiCalls";
import {
    setEndDate, getDefaultNameExactToMonths, setStartDate
} from "../common/DateMethods";
import SuspenseSpinner from "../../../Utils/SuspenseSpinner";
import SmartButton from "../common/SmartButton";
import {MAX_OUTPUT_FORM_NAME_LENGTH} from "../common/OutputFormsConstraints";
import {onDownloadFileAction} from "../common/OutputFormsDownloadFileFromConstructor";

export default function CreateDecadeOutputFormDialog({constructor, isShown, setIsShown, viaTemplateId= false, id, name}) {

    let [stationName, setStationName] = React.useState("")

    let [outputFormName, setOutputFormName] = React.useState(stationName)
    let [isOutputFormNameCustom, setIsOutputFormNameCustom] = React.useState(false)

    let [startPeriod, setStartPeriod] = React.useState("-01T00:00:01")
    let [endPeriod, setEndPeriod] = React.useState(setEndDate(''))

    const [isFetch, setIsFetch] = React.useState(false)

    function updateStationName() {
        setStationName(
            name !== undefined ?
                name !== "" ?
                    name :
                    checkConstructor
                : checkConstructor
        )
    }

    function checkConstructor() {
        return constructor.station.name !== undefined ?
            constructor.station.name !== "" ?
                constructor.station.name :
                ""
            : ""
    }

    function clearDialogFields() {
        setOutputFormName('')
        setStartPeriod('-01T00:00:01')
        setEndPeriod(setEndDate(''))
        setIsOutputFormNameCustom(false)
    }

    function isDateSetIncorrectly() {
        const start = new Date(startPeriod)
        const end = new Date(endPeriod)
        if (startPeriod !== '-01T00:00:01' && endPeriod !== setEndDate('')) {
            return start - end > 0
        }

        return false
    }


    function isFormButtonDisabled() {
        const start = new Date(startPeriod)
        const end = new Date(endPeriod)
        const dateIncorrect =  startPeriod === '-01T00:00:01' || endPeriod === setEndDate('') || start - end > 0

        return outputFormName.trim().length === 0 || isFetch || dateIncorrect
    }

    function getMessageForTooltip() {
        if (outputFormName.trim().length === 0 && (startPeriod === '-01T00:00:01' || endPeriod === setEndDate(''))) {
            return "Выберите период для которого будет сформирована выходная форма и задайте её наименование"
        }

        if (startPeriod === '-01T00:00:01' || endPeriod === setEndDate('')) {
            return "Выберите период для которого будет сформирована выходная форма"
        }

        if (outputFormName.trim().length === 0) {
            return "Задайте наименование для выходной формы"
        }

        const start = new Date(startPeriod)
        const end = new Date(endPeriod)
        if (start - end > 0) {
            return "Дата начала периода не может быть позднее, чем дата окончания этого периода"
        }
    }

    function createOutputForm() {
        const period = {
            start: startPeriod,
            end: endPeriod
        }

        if (outputFormName.length > MAX_OUTPUT_FORM_NAME_LENGTH) {
            toaster.danger("Ошибка! Наименование выходной формы не может быть длиннее " + MAX_OUTPUT_FORM_NAME_LENGTH
                +  " символов!")
            setIsFetch(false)
            return;
        }

        if (viaTemplateId) {
            generateExcelViaTemplateId(id, period, outputFormName).then((response) => {
                toaster.success('Файл сохранён!')
                clearDialogFields()
                setIsFetch(false)
            }).catch(() => {
                toaster.danger("Ошибка!")
                clearDialogFields()
                setIsFetch(false)
            })
        } else {
            generateExcel(period, constructor, outputFormName).then((response) => {
                toaster.success('Файл сохранён!')
                clearDialogFields()
                setIsFetch(false)
                //скачиваем форму сразу
                onDownloadFileAction(response.data.id)
            }).catch(() => {
                toaster.danger("Ошибка!")
                clearDialogFields()
                setIsFetch(false)
            })
        }
    }

    function setCustomOutputFormName(name) {
        setIsOutputFormNameCustom(true)
        setOutputFormName(name)
    }

    function getDefaultOutputFormName(stationName, startTime, endTIme) {
        if (isOutputFormNameCustom) {
            return outputFormName
        }

        return getDefaultNameExactToMonths(stationName, startTime, endTIme)
    }

    function setEndDateWithFormNameSaving(value) {
        updateStationName()
        setEndPeriod(setEndDate(value))

        if (!isOutputFormNameCustom) {
            setOutputFormName(
                getDefaultNameExactToMonths(
                    stationName,
                    startPeriod,
                    setEndDate(value)
                ))
        }
    }

    function setStartDateWithFormNameSaving(value) {
        updateStationName()
        setStartPeriod(setStartDate(value))

        if (!isOutputFormNameCustom) {
            setOutputFormName(
                getDefaultNameExactToMonths(
                    stationName,
                    setStartDate(value),
                    endPeriod
                ))
        }
    }


    return (
            <Dialog
                isShown={isShown}
                title="Формирование выходной формы"
                cancelLabel="Отменить"
                onOpenComplete={() => {
                    clearDialogFields()
                }}
                footer={
                    <Pane>
                        <Button marginRight={5} onClick={() => setIsShown(false)}>Отменить</Button>

                        <SmartButton
                            disabledTooltip={getMessageForTooltip()}
                            buttonText={"Сформировать"}
                            isPrimary={true}
                            isDisabled={isFormButtonDisabled()}
                            onClickAction={() => {
                                setIsFetch(true)
                                createOutputForm()
                            }}
                        />
                    </Pane>
                }
                onCloseComplete={() => setIsShown(false)}
            >
                {isFetch? <SuspenseSpinner/> :
                <>
                    <Pane>
                        <Label>Дата формирования</Label>
                    </Pane>
                    <Pane display={"flex"} marginTop={10}>
                        <Pane display={"flex"} columnGap={10}>
                            <Label>c</Label>
                            <TextInput
                                width="auto"
                                type="month"
                                isInvalid={isDateSetIncorrectly()}
                                name="startDate"
                                max={endPeriod}
                                onChange={val => {
                                    setStartDateWithFormNameSaving(val.target.value)
                                }}
                            />
                            <Label>по</Label>
                            <TextInput
                                width="auto"
                                type="month"
                                min={startPeriod}
                                isInvalid={isDateSetIncorrectly()}
                                name="endDate"
                                onChange={val => {
                                    setEndDateWithFormNameSaving(val.target.value)
                                }}
                            />
                        </Pane>
                    </Pane>
                    <Pane marginRight={30} marginTop={30}>
                        <TextInputField
                            label="Введите наименование выходной формы"
                            width={413}
                            value={
                                getDefaultOutputFormName(
                                    stationName,
                                    startPeriod,
                                    endPeriod
                                )}
                            onChange={e => setCustomOutputFormName(e.target.value)}
                        />
                    </Pane>
                </>}

            </Dialog>
        )
}
